// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wTEy","rootMobile":"styles_rootMobile__1BIJL"};